<script lang="ts">
  import { goto } from '$app/navigation';
  import Alert from '$lib/components/Alert.svelte';
  import Spinner from '$lib/components/Spinner.svelte';
  import { session } from '$lib/stores';
  import { onMount } from 'svelte';
  import { writable } from 'svelte/store';

  let status = writable<'loading' | 'success' | 'error' | null>(null);

  onMount(() => {
    if ($session) {
      goto('/', { replaceState: true, invalidateAll: true });
    }
  });

  const onSubmit = async (e: Event) => {
    const form = e.target as HTMLFormElement;
    const email = form.email.value;
    $status = 'loading';
    await fetch('/api/session/forgot-password', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email })
    });
    $status = 'success';
  };
</script>

<form on:submit|preventDefault={onSubmit}>
  <div>
    <h3 class="mb-6 text-center text-3xl font-extrabold text-primary-500" id="modal-title">
      ¿Olvidaste tu contraseña?
    </h3>

    {#if $status == 'loading'}
      <div class="flex justify-center p-8">
        <Spinner />
      </div>
    {:else if $status == 'success'}
      <Alert severity="success"
        >Se le ha enviado un correo con instrucciones para cambiar su contraseña</Alert
      >
    {:else if $status == 'error'}
      <Alert severity="danger">
        <p>Ha ocurrido un error, por favor vuelva a intentarlo.</p>
      </Alert>
    {:else}
      <div class="space-y-6">
        <div>
          <label for="email" class="block text-sm font-medium text-gray-700">
            Correo electrónico
          </label>
          <div class="mt-1">
            <input
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              required
              class="
              appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400
              focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm
            "
            />
          </div>
        </div>

        <button
          type="submit"
          class="
          w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm
          font-medium text-white bg-primary-500 hover:bg-primary-400 focus:outline-none focus:ring-2 focus:ring-offset-2
          focus:ring-primary-500
        "
        >
          Enviar
        </button>
      </div>
    {/if}
  </div>
</form>
